import {Icon, Integer} from 'platform/foundation';
import styled from 'styled-components';

interface AiComposerMarkProps {
  size: Integer;
}

interface TileProps {
  $size: Integer;
}

export function AiComposerMark(props: AiComposerMarkProps) {
  return (
    <Tile $size={props.size} aria-hidden>
      <Icon value="action/magic_wand" size={4} color="palettes.purple.90.100" />
    </Tile>
  );
}

const Tile = styled.span<TileProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: ${({theme, $size}) => theme.getSize($size)};
  height: ${({theme, $size}) => theme.getSize($size)};
  border-radius: ${({theme}) => theme.radii.medium};
  background: linear-gradient(
    160deg,
    ${({theme}) => theme.colors.palettes.purple[20][100]},
    ${({theme}) => theme.colors.palettes.blue[20][100]}
  );
`;
